import { render } from "./ImprintSection.vue?vue&type=template&id=918c88ec&scoped=true"
const script = {}

import "./ImprintSection.vue?vue&type=style&index=0&id=918c88ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-918c88ec"]])

export default __exports__